import React, { useContext, useState } from 'react';
import { Link, useNavigate, useParams, useLocation } from 'react-router-dom';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../url_variables';
import { TostMessageContext } from "../context/TostMessage";
import ReactLoading from 'react-loading';
import { FaCalendarAlt, FaUser, FaSignOutAlt, FaCogs, FaSearch } from "react-icons/fa";
import { IoMdChatboxes,IoIosArrowForward } from "react-icons/io";
import { AiOutlineClockCircle } from "react-icons/ai";
import { HiOutlineBookOpen } from "react-icons/hi";
import { MdOutlineDashboard, MdLanguage } from "react-icons/md";
import { UserContext } from '../context/UserContext';
import { Button } from '@chakra-ui/react';
import { routes } from "./routes";

export function RouteDisplay() {
    const { userProfile } = useContext(UserContext);
    const navigate = useNavigate();
    const params = useParams();
    const location = useLocation();

    const segments = location.pathname.split("/").filter(Boolean);

    let fullPath = "";
    const crumbs = segments.map((segment, index) => {
        fullPath += "/" + segment;
        const match = routes.find(r => r.path === fullPath);
        return {
        path: fullPath,
        label: match ? match.breadcrumb : segment,
        };
    });

    // var current_route = "Dashboard";
    // if (location.pathname == "/manage-child") {
    //     current_route +=  return <IoIosArrowForward /> + 'Manage Child';
    // }
    // if (location.pathname == "/create-child") {
    //     current_route += "manage-child" + <IoIosArrowForward /> + "create child";
    // }
  return (
        <div className="flex justify-start mb-6 w-full">
            <Link to="/home" className='text-[#8F8F8F] font-lighter text-xs hover:underline'>Dashboard</Link>
            {crumbs.map((crumb, index) => (
                <span key={index} className="flex justify-center items-center gap-1">
                <IoIosArrowForward color='#8F8F8F' size={13} />
                {index === crumbs.length - 1 ? (
                    <span className="text-black text-xs font-semibold">{crumb.label}</span>
                ) : (
                    <Link to={crumb.path} className="text-[#8F8F8F] text-xs hover:underline">{crumb.label}</Link>
                )}
                </span>
            ))}
        </div>
    )
}
